import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * A higher-order component that conditionally wraps its children with a given component.
 *
 * @component
 * @param {object} props - The component props.
 * @param {boolean} props.condition - The condition that determines whether to wrap the children.
 * @param {function} props.wrapper - A function that returns a JSX element that wraps the children if the condition is true.
 * @param {React.ReactNode} props.children - The children to wrap.
 * @returns {JSX.Element} - The wrapped children.
 */
const ConditionalWrapper = ({ condition, wrapper, children }) => condition ? wrapper(children) : _jsx(_Fragment, { children: children });
export default ConditionalWrapper;
//# sourceMappingURL=ConditionalWrapper.js.map